window.jQuery = window.$ = require('jquery');
window.isJilSander = true;

let processInclude = require('base/util');

function getHeaderHeight() {
  var root = document.documentElement;
  var headerHeight = $('.desktop-menu-wrapper')[0].clientHeight;
  var menuWidth = $('.desktop-menu-wrapper .mm-menu__primary__start .nav-primary')[0].clientWidth;
  var headerHeightWithTopBar = ($('.header-notification-slot-container.desktop-version')[0].clientHeight + $('.nav-desktop .mm-menu__primary__start')[0].clientHeight);
  root.style.setProperty('--header-height-calc', headerHeight + "px");
  root.style.setProperty('--menu-width-calc', menuWidth + "px");
  
  if ($('body').hasClass('home-page')) {
    root.style.setProperty('--header-height-with-top-bar', headerHeightWithTopBar + "px");
  }
}

  $('.header-banner .close-button').on('click', function() {
  setTimeout(() => {
    getHeaderHeight();
  }, 200);
  });

document.addEventListener("DOMContentLoaded", function() {
  processInclude(require('./components/wishlist'));
  processInclude(require('./login'));
  processInclude(require('tealium/tealiumEvents'));
  processInclude(require('./header-banner'));
  getHeaderHeight();

  setTimeout(() => {
    getHeaderHeight();
  }, 200);
});

function handleFooterAccordionToggle(clickedElement) {
  const $clickedBox = $(clickedElement).closest('.section-footer-box');
  $('.section-footer-box').each(function() {
      if ($(this).is($clickedBox)) {
          // Do nothing for the clicked box
          return;
      }
      $(this).removeClass('footer-accordeon-expanded').addClass('footer-accordeon-condensed');
  });
  if ($clickedBox.hasClass('footer-accordeon-expanded')) {
      $clickedBox.removeClass('footer-accordeon-expanded').addClass('footer-accordeon-condensed');
  } else {
      $clickedBox.removeClass('footer-accordeon-condensed').addClass('footer-accordeon-expanded');
  }
}

$('.button-open-footer').on('click', function() {
  handleFooterAccordionToggle(this);
});
